import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getArticles } from "../api/strapi";

const STRAPI_BASE_URL = "http://localhost:1337";

export default function TagArticles() {
    const { tag } = useParams();
    const [articles, setArticles] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        getArticles()
            .then(data => {
                const filtered = data.filter(a => a.tags && a.tags.includes(tag));
                setArticles(filtered);
            })
            .catch((err) => {
                console.error("Failed to fetch articles:", err);
                setError("Failed to fetch articles. Please make sure the Strapi backend is running.");
            });
    }, [tag]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const getFallbackExcerpt = (article) => {
        if (article.description) return article.description;
        if (!article.blocks || article.blocks.length === 0) return "No description available.";

        const richTextBlock = article.blocks.find(b => b.__component === "shared.rich-text");
        if (richTextBlock && richTextBlock.body) {
            const strippedText = richTextBlock.body.replace(/<[^>]+>/g, '');
            const firstSentenceMatch = strippedText.match(/[^.!?]+[.!?]+/);
            if (firstSentenceMatch) return firstSentenceMatch[0].trim();
            return strippedText.substring(0, 100).trim() + "...";
        }
        return "No description available.";
    };

    return (
        <div style={{ backgroundColor: "#FFF7F4", minHeight: "100vh" }}>
            <div className="container" style={{ padding: "40px 15px", paddingBottom: "100px" }}>
                <div style={{ marginBottom: "20px", fontSize: "0.9em" }}>
                    <Link to="/" style={{ textDecoration: "none", color: "#666" }}>Home</Link>
                    <span style={{ margin: "0 8px", color: "#aaa" }}>/</span>
                    <Link to="/recent-thoughts" style={{ textDecoration: "none", color: "#666" }}>Recent Thoughts</Link>
                    <span style={{ margin: "0 8px", color: "#aaa" }}>/</span>
                    <span style={{ color: "#333", fontWeight: "bold" }}>{tag}</span>
                </div>

                <h1 className="mb-5">Articles tagged with "{tag}"</h1>

                {error && <p style={{ color: "red" }}>{error}</p>}

                {!error && articles.length === 0 && <p>No articles found with this tag.</p>}

                <div className="row g-4 d-flex">
                    {articles.map((article, idx) => {
                        const bgColors = ['#eaf4f8', '#fde8ef', '#eaf6ec', '#fff1e6', '#f4eaf8', '#e6f5f3'];
                        const cardBg = bgColors[idx % bgColors.length];

                        return (
                            <div key={article.id} className="col-12 col-md-6 col-lg-4">
                                <div 
                                  className="card h-100 border-0 d-flex flex-column" 
                                  style={{ 
                                    backgroundColor: cardBg,
                                    borderRadius: "20px", 
                                    overflow: "hidden",
                                    boxShadow: "0 10px 28px rgba(0,0,0,0.03)",
                                    transition: "transform 0.2s ease" 
                                  }} 
                                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'} 
                                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div className="card-body d-flex flex-column p-4 p-md-5">
                                        {article.publishedAt && (
                                            <small className="text-muted mb-2 font-monospace">{formatDate(article.publishedAt)}</small>
                                        )}
                                        <h3 className="card-title text-dark fw-bold mb-3" style={{ fontSize: "1.25rem", lineHeight: "1.35" }}>
                                            {article.title}
                                        </h3>

                                        {article.tags && article.tags.length > 0 && (
                                            <div className="mb-3 d-flex flex-wrap gap-1">
                                                {article.tags.map(t => (
                                                    <span key={t} className="badge bg-light text-dark border me-1" style={{ zIndex: 2, position: "relative" }}>{t}</span>
                                                ))}
                                            </div>
                                        )}

                                        <p className="card-text text-secondary mb-4 flex-grow-1" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>{getFallbackExcerpt(article)}</p>
                                        <a href={`/recent-thoughts/${article.slug}`} className="stretched-link text-decoration-none fw-bold text-dark d-inline-flex align-items-center gap-2">
                                            <span>Read Article</span>
                                            <span>→</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
